import { Navigate, matchPath } from 'react-router-dom';

import { REMOTE_PERMISSIONS } from '@backrs_ui/common-ui';

import { APP_ROUTE, AppRoute, routePathPattern } from './appRoutes.constants';
import { sessionNames } from './components/SolutionSession/SessionStrings';
import { AssessMyTrackPage } from './pages/AssessMyTrack/AssessMyTrackPage';
import { AssessMyTrackPageResults } from './pages/AssessMyTrack/AssessMyTrackPageResults';
import { OAuthCallbackPage } from './pages/Auth/OAuthCallbackPage';
import { BookmarkPageContainer } from './pages/Bookmarks/pages/BookmarkPageContainer';
import { CareerPathPageContainer } from './pages/CareerPath/CareerPathPageContainer';
import { CareerTrackPageContainer } from './pages/CareerTrack/CareerTrackPageContainer';
import { MinimumTrackPageContainer } from './pages/CareerTrack/MinimumTrack/MinimumTrackPageContainer';
import { CoachesPageContainer } from './pages/Coaches/pages/CoachesPageContainer';
import {
  ANALYTICS_TAB_LABEL,
  analyticsTabFromSlug,
} from './pages/CoachingAnalytics/analytics.tabs';
import { CoachingAnalyticsPageContainer } from './pages/CoachingAnalytics/CoachingAnalyticsPageContainer';
import { CoachingDashboardPage } from './pages/CoachingDashboard/CoachingDashboardPage';
import { MemberDetailPage } from './pages/CoachingDashboard/MemberDetailPage';
import { CollegePageContainer } from './pages/College/CollegePageContainer';
import { CollegeApplicationRoadmapGuidePageContainer } from './pages/CollegeApplicationRoadmapGuide/pages/CollegeApplicationRoadmapGuidePageContainer';
import { CollegeVisitGuidePageContainer } from './pages/CollegeVisitGuide/pages/CollegeVisitGuidePageContainer';
import { ComingSoonPage } from './pages/ComingSoon/ComingSoonPage';
import { CommonAppEssayGuidePageContainer } from './pages/CommonAppEssayGuide/pages/CommonAppEssayGuidePageContainer';
import { CompetencyPageContainer } from './pages/Competency/pages/CompetencyPageContainer';
import { ConnectAppAuthorizePageContainer } from './pages/ConnectApp/ConnectAppAuthorizePageContainer';
import { CourseSelectionGuidePageContainer } from './pages/CourseSelectionGuide/pages/CourseSelectionGuidePageContainer';
import { DeepDiveDetailPageContainer } from './pages/DeepDives/pages/DeepDiveDetailPageContainer';
import { DeepDivesPageContainer } from './pages/DeepDives/pages/DeepDivesPageContainer';
import { EducationalInvestmentPageContainer } from './pages/EducationalInvestment/EducationalInvestmentPageContainer';
import { EmbeddedSitePage } from './pages/EmbeddedSitePage/EmbeddedSitePage';
import { EmployerPageContainer } from './pages/Employer/EmployerPageContainer';
import { ExtracurricularsGuidePageContainer } from './pages/ExtracurricularsGuide/pages/ExtracurricularsGuidePageContainer';
import { GeneratingBlueprintPageContainer } from './pages/Generating/GeneratingBlueprintPageContainer';
import { GpaGuidePageContainer } from './pages/GpaGuide/pages/GpaGuidePageContainer';
import { HomePageContainer } from './pages/Home/HomePageContainer';
import { IndustriesPageContainer } from './pages/Industries/IndustriesPageContainer';
import { InternshipPageContainer } from './pages/Internship/InternshipPageContainer';
import { InternshipGuidePageContainer } from './pages/InternshipGuide/pages/InternshipGuidePageContainer';
import { LifeReadinessPageContainer } from './pages/LifeReadiness/LifeReadinessPageContainer';
import { LoginPageContainer } from './pages/Login/LoginPageContainer';
import { OneTimePasswordContainer } from './pages/Login/OneTimePasswordContainer';
import { MajorsPageContainer } from './pages/Majors/MajorsPageContainer';
import { CareerRelevancePageContainer } from './pages/MajorsGuide/pages/CareerRelevancePageContainer';
import { CollegeGuidePageContainer } from './pages/MajorsGuide/pages/CollegeGuidePageContainer';
import { GradSchoolGuidePageContainer } from './pages/MajorsGuide/pages/GradSchoolGuidePageContainer';
import { MajorsGuidePageContainer } from './pages/MajorsGuide/pages/MajorsGuidePageContainer';
import { SearchMajorsPageContainer } from './pages/MajorsGuide/pages/SearchMajorsPageContainer';
import { MarkersOfSuccessPageContainer } from './pages/MarkersOfSuccess/MarkersOfSuccessPageContainer';
import { ComparePageContainer } from './pages/MyColleges/Compare/ComparePageContainer';
import { MyCollegesPageContainer } from './pages/MyColleges/MyCollegesPageContainer';
import { NotFound404Page } from './pages/NotFound404/NotFound404Page';
import { NuggetPage } from './pages/NuggetPage/NuggetPage';
import { SharedOfficeHoursPage } from './pages/OfficeHours/SharedOfficeHoursPage';
import { SignUpPageContainer } from './pages/Onboarding/SignUpPageContainer';
import { OnlineReputationGuidePageContainer } from './pages/OnlineReputationGuide/pages/OnlineReputationGuidePageContainer';
import { PlaybookPageContainer } from './pages/Priorities/pages/PlaybookPageContainer';
import { TaskPageContainer } from './pages/Priorities/pages/TaskPageContainer';
import { PrioritiesPageContainer } from './pages/Priorities/PrioritiesPageContainer';
import { ProfilePageContainer } from './pages/Profile/ProfilePageContainer';
import { ProsperPageContainer } from './pages/Prosper/pages/ProsperPageContainer';
import { RegistrationPage } from './pages/Register/RegistrationPage';
import { ResetPasswordPageContainer } from './pages/ResetPassword/ResetPasswordPageContainer';
import { MyResultsPageContainer } from './pages/Result/MyResultsPageContainer';
import { RostersAdminPageContainer } from './pages/RostersAdmin/RostersAdminPageContainer';
import { GeneratingPlanPageContainer } from './pages/SatActBooster/GeneratingPlanPageContainer';
import { SatActBoosterPageContainer } from './pages/SatActBooster/SatActBoosterPageContainer';
import { SatActBoosterResultPageContainer } from './pages/SatActBooster/SatActBoosterResultPageContainer';
import { SearchPageContainer } from './pages/Search/pages/SearchPageContainer';
import { SettingsPageContainer } from './pages/Settings/SettingsPageContainer';
import { SharedSessionGrantsPageContainer } from './pages/SharedSessionGrants/SharedSessionGrantsPageContainer';
import { SharedSolutionSessionPage } from './pages/SolutionSession/SharedSolutionSessionPage';
import { SolutionSessionRouteEntry } from './pages/SolutionSession/SolutionSessionPage';
import { StandardizedTestsGuidePageContainer } from './pages/StandardizedTestsGuide/pages/StandardizedTestsGuidePageContainer';
import { StudyHabitsGuidePageContainer } from './pages/StudyHabitsGuide/pages/StudyHabitsGuidePageContainer';
import { SubscriptionReturnPage } from './pages/Subscription/components/SubscriptionReturnPage';
import { SubscriptionPageContainer } from './pages/Subscription/SubscriptionPageContainer';
import { SurveyPageContainer } from './pages/Survey/SurveyPageContainer';
import { ToolsPageContainer } from './pages/Tools/ToolsPageContainer';
import { VerifyEmailPage } from './pages/VerifyEmail/VerifyEmailPage';
import { FeatureFlaggedRoute } from './providers/FeatureFlaggedRoute';
import { SharedSessionProvider } from './providers/SharedSessionProvider';
import { FEATURE_FLAGS } from './redux/featureFlags/featureFlags';
import { PAYWALL_PERMISSIONS } from './redux/user/user.transformer';
import { isSandboxStudent } from './utils/sandboxSession';

export const APP_ROUTES: Record<keyof typeof APP_ROUTE, AppRoute> = {
  HOME: {
    protected: false,
    path: APP_ROUTE.HOME,
    page: <HomePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Home',
    shellMode: { layout: 'resourceTabsOnly', lubavPanel: 'small' },
    maxWidth: 'width-default',
  },
  LOGIN: {
    protected: false,
    path: APP_ROUTE.LOGIN,
    page: <LoginPageContainer />,
    legacyPageType: 'UNAUTHENTICATED',
    title: 'Login',
    shellMode: { lubavPanel: 'hidden' },
  },
  OTP: {
    protected: false,
    path: APP_ROUTE.OTP,
    page: <OneTimePasswordContainer />,
    legacyPageType: 'UNAUTHENTICATED',
    title: 'Login',
    shellMode: { lubavPanel: 'hidden' },
  },
  REGISTER: {
    protected: false,
    path: APP_ROUTE.REGISTER,
    page: <RegistrationPage />,
    legacyPageType: 'UNAUTHENTICATED',
    title: 'Register',
    shellMode: { lubavPanel: 'hidden' },
  },
  SIGN_UP: {
    protected: false,
    path: APP_ROUTE.SIGN_UP,
    page: <SignUpPageContainer />,
    legacyPageType: 'UNAUTHENTICATED',
    title: 'Sign Up',
    shellMode: { lubavPanel: 'hidden' },
  },
  VERIFY_EMAIL: {
    protected: false,
    path: APP_ROUTE.VERIFY_EMAIL,
    page: <VerifyEmailPage />,
    legacyPageType: 'UNAUTHENTICATED',
    title: 'Verify Email',
  },
  RESET_PASSWORD: {
    protected: false,
    path: APP_ROUTE.RESET_PASSWORD,
    page: <ResetPasswordPageContainer />,
    legacyPageType: 'UNAUTHENTICATED',
    title: 'Reset Password',
    shellMode: { lubavPanel: 'hidden' },
  },
  AUTH_CALLBACK: {
    protected: false,
    path: APP_ROUTE.AUTH_CALLBACK,
    page: <OAuthCallbackPage />,
    legacyPageType: 'UNAUTHENTICATED',
    title: 'Signing in...',
    shellMode: { lubavPanel: 'hidden' },
  },
  CONNECT_APP_AUTHORIZE: {
    protected: false,
    path: APP_ROUTE.CONNECT_APP_AUTHORIZE,
    page: <ConnectAppAuthorizePageContainer />,
    legacyPageType: 'UNAUTHENTICATED',
    title: 'Connect your account',
    shellMode: { lubavPanel: 'hidden' },
  },
  TOOLS: {
    protected: false,
    path: APP_ROUTE.TOOLS,
    page: <ToolsPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Backrs Tools',
    maxWidth: 'width-3xl',
  },
  SAT_ACT_BOOSTER: {
    protected: false,
    path: APP_ROUTE.SAT_ACT_BOOSTER,
    page: (
      <FeatureFlaggedRoute flag={FEATURE_FLAGS.TEST_BOOSTER}>
        <SatActBoosterPageContainer />
      </FeatureFlaggedRoute>
    ),
    legacyPageType: 'BACKRS_4.0',
    title: 'Test Booster',
    maxWidth: 'width-3xl',
  },
  SAT_ACT_BOOSTER_GENERATING: {
    protected: false,
    path: APP_ROUTE.SAT_ACT_BOOSTER_GENERATING,
    page: (
      <FeatureFlaggedRoute flag={FEATURE_FLAGS.TEST_BOOSTER}>
        <GeneratingPlanPageContainer />
      </FeatureFlaggedRoute>
    ),
    legacyPageType: 'BACKRS_4.0',
    title: 'Test Booster',
    maxWidth: 'width-3xl',
  },
  SAT_ACT_BOOSTER_RESULT: {
    protected: false,
    path: APP_ROUTE.SAT_ACT_BOOSTER_RESULT,
    page: (
      <FeatureFlaggedRoute flag={FEATURE_FLAGS.TEST_BOOSTER}>
        <SatActBoosterResultPageContainer />
      </FeatureFlaggedRoute>
    ),
    legacyPageType: 'BACKRS_4.0',
    title: 'Test Booster',
    maxWidth: 'width-3xl',
  },

  UNIVERSITY: {
    protected: true,
    path: APP_ROUTE.UNIVERSITY,
    page: <CollegePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    subRoute: 'universityId',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'University',
  },

  EMPLOYER: {
    protected: true,
    path: APP_ROUTE.EMPLOYER,
    page: <EmployerPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    subRoute: 'employerSlug',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Employer',
  },

  INTERNSHIP: {
    protected: true,
    path: APP_ROUTE.INTERNSHIP,
    page: <InternshipPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    subRoute: 'internshipId',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Opportunity',
  },

  LIFE_READINESS: {
    protected: true,
    path: APP_ROUTE.LIFE_READINESS, // "/life-readiness"
    page: <LifeReadinessPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    subRoute: 'categoryId',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Life Readiness',
  },

  LIFE_READINESS_QUIZ: {
    protected: true,
    path: APP_ROUTE.LIFE_READINESS_QUIZ, // "/life-readiness/:categoryId/:subcategoryId"
    page: <LifeReadinessPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Life Readiness',
  },

  PROFILE: {
    protected: true,
    path: APP_ROUTE.PROFILE,
    page: <ProfilePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    subRoute: 'profile',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    shellMode: { lubavPanel: (params) => (params.profile ? 'small' : 'hidden') },
    title: 'Profile',
    maxWidth: 'width-default',
  },

  SETTINGS: {
    protected: true,
    path: APP_ROUTE.SETTINGS,
    page: <SettingsPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Settings',
    shellMode: { lubavPanel: 'hidden' },
    maxWidth: 'width-default',
  },

  SHARED_SESSION_GRANTS: {
    protected: true,
    path: APP_ROUTE.SHARED_SESSION_GRANTS,
    page: <SharedSessionGrantsPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Shared Session Grants',
    shellMode: { lubavPanel: 'hidden' },
    maxWidth: 'width-xl',
  },

  SUBSCRIPTION: {
    protected: false,
    path: APP_ROUTE.SUBSCRIPTION,
    page: <SubscriptionPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Subscription',
    shellMode: { lubavPanel: 'hidden' },
  },

  SUBSCRIPTION_RETURN: {
    protected: true,
    path: APP_ROUTE.SUBSCRIPTION_RETURN,
    page: <SubscriptionReturnPage />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Subscription Return',
    shellMode: { lubavPanel: 'hidden' },
  },

  PRIORITIES: {
    protected: true,
    path: APP_ROUTE.PRIORITIES,
    page: <PrioritiesPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    subRoute: 'playbook',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    maxWidth: 'width-3xl',
    title: (params) => {
      const playbook = params.playbook;

      return playbook ? `Playbooks - ${playbook}` : 'Playbooks';
    },
  },

  PLAYBOOK: {
    protected: true,
    path: APP_ROUTE.PLAYBOOK,
    page: <PlaybookPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    maxWidth: 'width-3xl',
    title: 'Playbook',
  },

  PLAYBOOK_TASK: {
    protected: true,
    path: APP_ROUTE.PLAYBOOK_TASK,
    page: <TaskPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    maxWidth: 'width-3xl',
    title: 'Task',
  },

  EDUCATIONAL_INVESTMENT: {
    protected: true,
    path: APP_ROUTE.EDUCATIONAL_INVESTMENT,
    page: <EducationalInvestmentPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Educational Investment',
    maxWidth: 'width-3xl',
  },

  // TODO: This will be used to render individual educational investments once that page is built
  EDUCATIONAL_INVESTMENT_WITH_CODE: {
    protected: true,
    path: APP_ROUTE.EDUCATIONAL_INVESTMENT_WITH_CODE,
    page: <EducationalInvestmentPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Educational Investment',
    maxWidth: 'width-3xl',
  },

  CAREER_PATHS: {
    protected: true,
    path: APP_ROUTE.CAREER_PATHS,
    page: <CareerPathPageContainer />,
    subRoute: 'careerPathId',
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Guide to Career Paths',
    maxWidth: '936px',
  },
  CAREER_TRACKS: {
    protected: true,
    path: APP_ROUTE.CAREER_TRACKS,
    page: <CareerTrackPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Career Tracks',
  },
  MINIMUM_TRACK: {
    protected: true,
    path: APP_ROUTE.MINIMUM_TRACK,
    page: <MinimumTrackPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Minimum Track',
    maxWidth: 'width-3xl',
  },
  SURVEY: {
    protected: true,
    path: APP_ROUTE.SURVEY,
    page: <SurveyPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Blueprint',
  },
  GENERATING_BLUEPRINT: {
    protected: true,
    path: APP_ROUTE.GENERATING_BLUEPRINT,
    page: <GeneratingBlueprintPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Blueprint',
  },
  MY_BLUEPRINT: {
    protected: true,
    path: APP_ROUTE.MY_BLUEPRINT,
    page: <MyResultsPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'My Blueprint',
    maxWidth: 'width-3xl',
  },

  // DEMO BLUEPRINT ROUTES (for demos - unauthenticated)
  DEMO_SURVEY: {
    protected: false,
    path: APP_ROUTE.DEMO_SURVEY,
    page: <SurveyPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Blueprint',
  },
  DEMO_GENERATING_BLUEPRINT: {
    protected: false,
    path: APP_ROUTE.DEMO_GENERATING_BLUEPRINT,
    page: <GeneratingBlueprintPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Blueprint',
  },
  DEMO_MY_BLUEPRINT: {
    protected: false,
    path: APP_ROUTE.DEMO_MY_BLUEPRINT,
    page: <MyResultsPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'My Blueprint',
    maxWidth: 'width-3xl',
  },

  // SHARED BLUEPRINT ROUTES
  SHARED_CAREER_PATHS: {
    protected: false,
    path: APP_ROUTE.SHARED_CAREER_PATHS,
    page: (
      <SharedSessionProvider>
        <CareerPathPageContainer isShared={true} />
      </SharedSessionProvider>
    ),
    subRoute: 'careerPathId',
    legacyPageType: 'BACKRS_4.0',
    title: 'Guide to Career Paths',
  },
  SHARED_MINIMUM_TRACK: {
    protected: false,
    path: APP_ROUTE.SHARED_MINIMUM_TRACK,
    page: (
      <SharedSessionProvider>
        <MinimumTrackPageContainer isShared={true} />
      </SharedSessionProvider>
    ),
    legacyPageType: 'BACKRS_4.0',
    title: 'Minimum Track',
    maxWidth: 'width-3xl',
  },
  SHARED_MY_BLUEPRINT: {
    protected: false,
    path: APP_ROUTE.SHARED_MY_BLUEPRINT,
    page: (
      <SharedSessionProvider>
        <MyResultsPageContainer isShared={true} />
      </SharedSessionProvider>
    ),
    legacyPageType: 'BACKRS_4.0',
    title: 'My Blueprint',
    maxWidth: 'width-3xl',
  },

  SHARED_EDUCATIONAL_INVESTMENT: {
    protected: false,
    path: APP_ROUTE.SHARED_EDUCATIONAL_INVESTMENT,
    page: (
      <SharedSessionProvider>
        <EducationalInvestmentPageContainer isShared={true} />
      </SharedSessionProvider>
    ),
    legacyPageType: 'BACKRS_4.0',
    title: 'Educational Investment',
    maxWidth: 'width-3xl',
  },

  SHARED_SOLUTION_SESSION: {
    protected: false,
    path: APP_ROUTE.SHARED_SOLUTION_SESSION,
    page: (
      <SharedSessionProvider>
        <SharedSolutionSessionPage />
      </SharedSessionProvider>
    ),
    title: 'Solution Session',
  },

  SHARED_OFFICE_HOURS_SESSION: {
    protected: false,
    path: APP_ROUTE.SHARED_OFFICE_HOURS_SESSION,
    page: (
      <SharedSessionProvider>
        <SharedOfficeHoursPage />
      </SharedSessionProvider>
    ),
    legacyPageType: 'BACKRS_4.0',
    shellMode: { layout: 'resourceTabsOnly', lubavPanel: 'large' },
    title: 'Office Hours',
  },

  MARKERS_OF_SUCCESS: {
    protected: true,
    path: APP_ROUTE.MARKERS_OF_SUCCESS,
    page: <MarkersOfSuccessPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Markers of Success',
    shellMode: { lubavPanel: 'hidden' },
    maxWidth: 'width-default',
  },

  LIBRARY: {
    protected: true,
    path: APP_ROUTE.LIBRARY,
    page: <ProsperPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Competency Library',
    maxWidth: '1304px',
  },
  COMPETENCY: {
    protected: true,
    path: APP_ROUTE.COMPETENCY,
    queryParam: ['slug'],
    subRoute: 'slug',
    page: <CompetencyPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Competency',
  },
  SEARCH: {
    protected: false,
    path: APP_ROUTE.SEARCH,
    page: <SearchPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    subRoute: 'subPageCategory',
    title: 'Search',
    maxWidth: 'width-3xl',
  },
  BOOKMARKS: {
    protected: true,
    path: APP_ROUTE.BOOKMARKS,
    page: <BookmarkPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Bookmarks',
    maxWidth: 'width-3xl',
  },
  MY_COLLEGES: {
    protected: true,
    path: APP_ROUTE.MY_COLLEGES,
    page: <MyCollegesPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'My College List',
    maxWidth: 'width-3xl',
  },
  COMPARE_COLLEGES: {
    protected: true,
    path: APP_ROUTE.COMPARE_COLLEGES,
    page: <ComparePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Compare Colleges',
    maxWidth: 'width-3xl',
  },

  DEEP_DIVES: {
    protected: true,
    path: APP_ROUTE.DEEP_DIVES,
    page: <DeepDivesPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    redirectIfMissingPermissions: [REMOTE_PERMISSIONS.ACCESS_DEEP_DIVES],
    title: 'Deep Dives',
    maxWidth: 'width-default',
  },
  DEEP_DIVE_DETAIL: {
    protected: true,
    path: APP_ROUTE.DEEP_DIVE_DETAIL,
    page: <DeepDiveDetailPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    redirectIfMissingPermissions: [REMOTE_PERMISSIONS.ACCESS_DEEP_DIVES],
    title: 'Deep Dive',
    maxWidth: 'width-2xl',
  },

  COACHES: {
    protected: true,
    path: APP_ROUTE.COACHES,
    page: <CoachesPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    redirectIfMissingPermissions: [REMOTE_PERMISSIONS.ACCESS_COACHES],
    title: 'Coaches',
  },

  COACHING_DASHBOARD: {
    protected: true,
    path: APP_ROUTE.COACHING_DASHBOARD,
    page: <CoachingDashboardPage />,
    legacyPageType: 'LUBAV_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Coaching Dashboard',
    shellMode: { lubavPanel: 'hidden' },
    background: 'white',
  },
  COACHING_ANALYTICS: {
    protected: true,
    path: APP_ROUTE.COACHING_ANALYTICS,
    page: <CoachingAnalyticsPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    subRoute: 'tab',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    redirectIfMissingPermissions: [REMOTE_PERMISSIONS.ACCESS_COHORT_ANALYTICS],
    title: (params) => {
      const tab = analyticsTabFromSlug(params.tab);

      return tab && tab !== 'overview' ? `Analytics - ${ANALYTICS_TAB_LABEL[tab]}` : 'Analytics';
    },
    shellMode: { lubavPanel: 'small' },
    background: 'default',
  },
  ROSTERS_ADMIN: {
    protected: true,
    path: APP_ROUTE.ROSTERS_ADMIN,
    page: <RostersAdminPageContainer />,
    legacyPageType: 'LUBAV_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    redirectIfMissingPermissions: [REMOTE_PERMISSIONS.MANAGE_INSTITUTION_MEMBERS],
    title: 'Cohorts',
    shellMode: { lubavPanel: 'hidden' },
    background: 'white',
  },
  COACHING_DASHBOARD_MEMBER: {
    protected: true,
    path: APP_ROUTE.COACHING_DASHBOARD_MEMBER,
    page: <MemberDetailPage />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Coaching Dashboard Details',
    shellMode: {
      layout: 'resourceTabsOnly',
      lubavPanel: 'large',
      staticTabs: ['memberProfile', 'memberSessions', 'memberNotes'],
    },
  },
  OFFICE_HOURS_SUPERUSER: {
    protected: true,
    path: APP_ROUTE.OFFICE_HOURS_SUPERUSER,
    page: <></>,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Superuser',
    shellMode: { layout: 'resourceTabsOnly', lubavPanel: 'large' },
  },
  OFFICE_HOURS: {
    protected: true,
    path: APP_ROUTE.OFFICE_HOURS,
    page: <Navigate to="/" replace />,
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Office Hours',
    shellMode: { lubavPanel: 'hidden' },
  },
  OFFICE_HOURS_SESSION: {
    protected: true,
    path: APP_ROUTE.OFFICE_HOURS_SESSION,
    page: <></>,
    legacyPageType: 'BACKRS_4.0',
    shellMode: { layout: 'resourceTabsOnly', lubavPanel: 'large' },
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: () => 'Office Hours',
  },
  SOLUTION_SESSION: {
    protected: true,
    path: APP_ROUTE.SOLUTION_SESSION,
    page: <SolutionSessionRouteEntry />,
    legacyPageType: 'LUBAV_4.0',
    subRoute: 'sessionId',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: (params, pathname) => {
      const sessionId = params.id || pathname.split('/solution-session/')[1]?.split('/')[0];

      if (sessionId) {
        const sessionName = sessionNames[sessionId as keyof typeof sessionNames];

        if (sessionName) {
          return sessionName;
        }
      }

      return 'Solution Session';
    },
    shellMode: { lubavPanel: 'hidden' },
  },

  ASSESS_MY_TRACK: {
    protected: true,
    path: APP_ROUTE.ASSESS_MY_TRACK,
    page: <AssessMyTrackPage />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Are You On Track',
    maxWidth: 'width-3xl',
  },
  ASSESS_MY_TRACK_RESULT: {
    protected: true,
    path: APP_ROUTE.ASSESS_MY_TRACK_RESULT,
    page: <AssessMyTrackPageResults />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Track Assessment Results',
    maxWidth: 'width-3xl',
  },

  NUGGETS: {
    protected: true,
    path: APP_ROUTE.NUGGETS,
    page: <NuggetPage />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Competency Library',
    maxWidth: 'width-xl',
  },

  // ALL OTHERS (404)
  NOT_FOUND: {
    protected: false,
    path: '*',
    page: <NotFound404Page />,
    legacyPageType: 'UNAUTHENTICATED',
    title: 'Page Not Found',
    shellMode: { lubavPanel: 'hidden' },
  },
  NOT_FOUND_404: {
    protected: false,
    path: APP_ROUTE.NOT_FOUND_404,
    page: <NotFound404Page />,
    legacyPageType: 'UNAUTHENTICATED',
    title: 'Page Not Found',
    shellMode: { lubavPanel: 'hidden' },
  },
  COMING_SOON: {
    protected: true,
    path: APP_ROUTE.COMING_SOON,
    page: <ComingSoonPage />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Coming Soon',
    shellMode: { lubavPanel: 'hidden' },
  },
  MAJORS_DETAIL: {
    protected: true,
    path: APP_ROUTE.MAJORS_DETAIL,
    page: <MajorsPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Majors',
    maxWidth: '936px',
  },
  INDUSTRIES: {
    protected: true,
    path: APP_ROUTE.INDUSTRIES,
    page: <IndustriesPageContainer />,
    subRoute: 'industryId',
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Industries',
  },
  SUCCESS_SYSTEM: {
    protected: false,
    path: APP_ROUTE.SUCCESS_SYSTEM,
    page: <EmbeddedSitePage type="success-system" />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Success System',
  },
  KEY_LEVERS: {
    protected: false,
    path: APP_ROUTE.KEY_LEVERS,
    page: <EmbeddedSitePage type="key-levers" />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Key Levers',
  },
  GPA_GUIDE: {
    protected: false,
    path: APP_ROUTE.GPA_GUIDE,
    page: <GpaGuidePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'GPA Guide',
    maxWidth: 'width-3xl',
  },
  COMMON_APP_ESSAY_GUIDE: {
    protected: false,
    path: APP_ROUTE.COMMON_APP_ESSAY_GUIDE,
    page: <CommonAppEssayGuidePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Common App Essay Guide',
    maxWidth: 'width-3xl',
  },
  COURSE_SELECTION_GUIDE: {
    protected: false,
    path: APP_ROUTE.COURSE_SELECTION_GUIDE,
    page: <CourseSelectionGuidePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Course Selection Guide',
    maxWidth: 'width-3xl',
  },
  COLLEGE_APPLICATION_ROADMAP_GUIDE: {
    protected: false,
    path: APP_ROUTE.COLLEGE_APPLICATION_ROADMAP_GUIDE,
    page: <CollegeApplicationRoadmapGuidePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'College Application Roadmap',
    maxWidth: 'width-3xl',
  },
  STUDY_HABITS_GUIDE: {
    protected: false,
    path: APP_ROUTE.STUDY_HABITS_GUIDE,
    page: <StudyHabitsGuidePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Study Habits Guide',
    maxWidth: 'width-3xl',
  },
  STANDARDIZED_TESTS_GUIDE: {
    protected: false,
    path: APP_ROUTE.STANDARDIZED_TESTS_GUIDE,
    page: <StandardizedTestsGuidePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Standardized Tests Guide',
    maxWidth: 'width-3xl',
  },
  EXTRACURRICULARS_GUIDE: {
    protected: false,
    path: APP_ROUTE.EXTRACURRICULARS_GUIDE,
    page: <ExtracurricularsGuidePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Extracurriculars Guide',
    maxWidth: 'width-3xl',
  },
  INTERNSHIPS_GUIDE: {
    protected: false,
    path: APP_ROUTE.INTERNSHIPS_GUIDE,
    page: <InternshipGuidePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Internship Guide',
    maxWidth: 'width-3xl',
  },
  ONLINE_REPUTATION_GUIDE: {
    protected: false,
    path: APP_ROUTE.ONLINE_REPUTATION_GUIDE,
    page: <OnlineReputationGuidePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Online Reputation Guide',
    maxWidth: 'width-3xl',
  },
  COLLEGE_VISIT_GUIDE: {
    protected: false,
    path: APP_ROUTE.COLLEGE_VISIT_GUIDE,
    page: <CollegeVisitGuidePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'College Visit Guide',
    maxWidth: 'width-3xl',
  },
  MAJORS: {
    protected: false,
    path: APP_ROUTE.MAJORS,
    page: <MajorsGuidePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    title: 'Majors',
    maxWidth: 'width-3xl',
  },
  MAJORS_COLLEGE_GUIDE: {
    protected: true,
    path: APP_ROUTE.MAJORS_COLLEGE_GUIDE,
    page: <CollegeGuidePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'College Guide',
    maxWidth: 'width-3xl',
  },
  MAJORS_GRAD_SCHOOL_GUIDE: {
    protected: true,
    path: APP_ROUTE.MAJORS_GRAD_SCHOOL_GUIDE,
    page: <GradSchoolGuidePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Grad School Guide',
    maxWidth: 'width-3xl',
  },
  MAJORS_SEARCH: {
    protected: true,
    path: APP_ROUTE.MAJORS_SEARCH,
    page: <SearchMajorsPageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Search Majors',
    maxWidth: 'width-3xl',
  },
  MAJORS_EXPLORER: {
    protected: true,
    path: APP_ROUTE.MAJORS_EXPLORER,
    page: <CareerRelevancePageContainer />,
    legacyPageType: 'BACKRS_4.0',
    requiredPermissions: [PAYWALL_PERMISSIONS.ACCESS_GROW],
    title: 'Majors Explorer',
    maxWidth: 'width-3xl',
  },
};

export const PROTECTED_PATH_PATTERNS: string[] = Object.values(APP_ROUTES).flatMap((route) => {
  if (!route.protected) return [];

  const base = routePathPattern(route);

  return route.subRoute ? [base, `${base}/:${route.subRoute}`] : [base];
});

// Public pages outside the auth flow — the routes where a visitor without a session gets a guest one.
const GUEST_SESSION_PATH_PATTERNS: string[] = Object.values(APP_ROUTES).flatMap((route) => {
  if (route.protected || route.legacyPageType === 'UNAUTHENTICATED') return [];

  const base = routePathPattern(route);

  return route.subRoute ? [base, `${base}/:${route.subRoute}`] : [base];
});

export const isGuestSessionPath = (pathname: string): boolean =>
  GUEST_SESSION_PATH_PATTERNS.some((pattern) => matchPath(pattern, pathname) != null);

// Protected routes the staff sandbox still allows.
const SANDBOX_ALLOWED_PATHS: AppRoute['path'][] = [
  APP_ROUTE.COACHING_DASHBOARD,
  APP_ROUTE.COACHING_DASHBOARD_MEMBER,
  APP_ROUTE.COACHING_ANALYTICS,
  APP_ROUTE.ROSTERS_ADMIN,
];

// Unprotected non-auth routes the sandbox blocks. The auth flow is not listed
// here — it is derived below so a new auth route is blocked the day it is added.
const SANDBOX_BLOCKED_PUBLIC_PATHS: AppRoute['path'][] = [
  APP_ROUTE.SUBSCRIPTION,
  APP_ROUTE.SAT_ACT_BOOSTER,
  APP_ROUTE.SAT_ACT_BOOSTER_RESULT,
  APP_ROUTE.DEMO_SURVEY,
  APP_ROUTE.DEMO_GENERATING_BLUEPRINT,
  APP_ROUTE.DEMO_MY_BLUEPRINT,
];

// The not-found routes share the auth flow's page type without being part of it,
// and NOT_FOUND's '*' would match every path.
const isSandboxAuthFlowRoute = (route: AppRoute): boolean =>
  route.legacyPageType === 'UNAUTHENTICATED' &&
  route.path !== APP_ROUTE.NOT_FOUND &&
  route.path !== APP_ROUTE.NOT_FOUND_404;

// Protected routes a demo student cannot reach: the account pages and the staff pages.
const SANDBOX_STUDENT_BLOCKED_PATHS: AppRoute['path'][] = [
  APP_ROUTE.SETTINGS,
  APP_ROUTE.SUBSCRIPTION_RETURN,
  ...SANDBOX_ALLOWED_PATHS,
];

const isSandboxBlockedPublicRoute = (route: AppRoute): boolean =>
  isSandboxAuthFlowRoute(route) || SANDBOX_BLOCKED_PUBLIC_PATHS.includes(route.path);

const sandboxBlockedPathPatterns = (isProtectedRouteBlocked: (route: AppRoute) => boolean) =>
  Object.values(APP_ROUTES).flatMap((route) => {
    const isBlocked = route.protected
      ? isProtectedRouteBlocked(route)
      : isSandboxBlockedPublicRoute(route);

    if (!isBlocked) return [];

    const base = routePathPattern(route);

    return route.subRoute ? [base, `${base}/:${route.subRoute}`] : [base];
  });

const SANDBOX_BLOCKED_PATH_PATTERNS = sandboxBlockedPathPatterns(
  (route) => !SANDBOX_ALLOWED_PATHS.includes(route.path),
);

const SANDBOX_STUDENT_BLOCKED_PATH_PATTERNS = sandboxBlockedPathPatterns((route) =>
  SANDBOX_STUDENT_BLOCKED_PATHS.includes(route.path),
);

export const isSandboxBlockedPath = (pathname: string): boolean =>
  (isSandboxStudent() ? SANDBOX_STUDENT_BLOCKED_PATH_PATTERNS : SANDBOX_BLOCKED_PATH_PATTERNS).some(
    (pattern) => matchPath(pattern, pathname) != null,
  );
